import { UnitType } from '@exodus/currency'

const name = 'lisk'
const displayName = 'Lisk'
const ticker = 'LSK'
const displayTicker = 'LSK'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#6EBEDC'
const gradientColors = ['#6EBEDC', '#1458DD']
const gradientCoords = { x1: '100%', y1: '100%', x2: '0%', y2: '0%' }
const chainBadgeColors = gradientColors

const units = {
  Shards: 0,
  LSK: 8,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://lisk.observer/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://lisk.observer/transaction/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Lisk is a multi-purpose blockchain that inspires, enables and supports developers to build blockchain applications written in JavaScript.',
  reddit: 'https://www.reddit.com/r/Lisk',
  twitter: 'https://twitter.com/LiskHQ',
  website: 'https://lisk.io/',
  telegram: 'https://t.me/Lisk_HQ',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
